import callApi from './callApi';
export const listAllTestCycles = (
  page,
  perPage,
  searchValue,
  queryString,
  projectId,
  sortBy,  
  sortOrder   
) => {
  const url = `testcycles?projectId=${projectId}&page=${page}&perPage=${perPage}&search=${searchValue}${
    queryString ? `&${queryString}` : ''
  }${sortBy ? `&sortBy=${sortBy}` : ''}${sortOrder ? `&sortOrder=${sortOrder}` : ''}`;
  return callApi(url, {}, 'GET');
};

export const createTestCycle = async (payload, projectId) => {
  const url = `testcycles?projectId=${projectId}`;
  const headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    ...payload,
  };
  return await callApi(url, headers, 'POST', body);
};

export const fetchTestCycle = async (testCycleKey, projectId) => {
  const url = `testcycles/${testCycleKey}`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return callApi(url, headers, 'GET');
};

export const fetchTestCycleHistory = async (testCycleId) => {
  const url = `testcycles/history/${testCycleId}`;
  return callApi(url, {}, 'GET');
};

export const updateTestCycle = (testCycleId, data) => {
  const url = `testcycles/${testCycleId}`;
  let body = {
    ...data,
  };
  return callApi(url, {}, 'PUT', body);
};

export const completeTestCycle = (testCycleId) => {
  const url = `testcycles/completed/${testCycleId}`;
  return callApi(url, {}, 'GET');
};

export const cloneTestCycle = (projectId, data) => {
  const url = `testcycles/clone?projectId=${projectId}`;
  return callApi(url, {}, 'POST', data);
};

export const deleteTestCycle = (data) => {
  const url = `testcycles/delete`;
  return callApi(url, {}, 'POST', data);
};

export const associateTestCasesBulk = (testCycleId, data) => {
  const url = `associations/bulkcreate/${testCycleId}`;
  return callApi(url, {}, 'POST', data);
}

export const removeAssociationsBulk = (data, projectId) => {
  const url = `associations/delete?projectId=${projectId}`;
  return callApi(url, {}, 'POST', data);
};

export const bulkUpdateAssociations = (data, testCycleId) => {
  const url = `associations/bulkUpdate/${testCycleId}`;
  return callApi(url, {}, 'PUT', data);
};

export const updateTestCaseAssociations = (id, executionId, skip = false) => {
  const skipParam = skip ? '&skip=true' : '';
  const url = `associations/update/${id}?executionId=${executionId}${skipParam}`;
  return callApi(url, {}, 'GET');
};

export const updateTestCycleStatus = (id) => ({
  path: `plugin/testcycles/completed/${id}`,
  method: 'PUT',
  headers: {},
});

export const getCycleReport = (testCycleId, projectId, filters = {}) => {
  const params = new URLSearchParams({ projectId });
  if (filters.environment) params.set('environment', filters.environment);
  if (filters.country?.length) filters.country.forEach(c => params.append('country', c));
  const url = `testcycles/report/cycle/${testCycleId}?${params.toString()}`;
  return callApi(url, {}, 'GET');
};

export const getCycleStatusBreakdown = async (testCycleId, projectId, filters = {}) => {
  const params = new URLSearchParams({ projectId });

  if (filters.environment) params.set('environment', filters.environment);
  if (filters.country) params.set('country', filters.country);

  const url = `testcycles/report/cycle/${testCycleId}/status-breakdown?${params.toString()}`;
  return callApi(url, {}, 'GET');
};
 
export const getIterationReport = (testCycleId, projectId, iterationIds = []) => {
  const base = `testcycles/report/iterations/${testCycleId}?projectId=${projectId}`;
  const suffix = iterationIds.length ? `&iterationIds=${iterationIds.join(',')}` : '';
  return callApi(`${base}${suffix}`, {}, 'GET');
};